<fieldset>
  <legend style="display: none">{{ attribute.label }}</legend>
  <div id="{{ createAttributeIdForConfigurator(attribute) }}">
    <div
      *ngIf="withQuantityOnAttributeLevel"
      class="cx-attribute-level-quantity-price"
    >
      <cx-configurator-attribute-quantity
        (changeQuantity)="onChangeQuantity($event)"
        [quantityOptions]="
          extractQuantityParameters(attribute.quantity, !attribute.required)
        "
      ></cx-configurator-attribute-quantity>
      <cx-configurator-price
        [formula]="extractPriceFormulaParameters()"
      ></cx-configurator-price>
    </div>
    <ng-container *ngFor="let value of attribute.values; let i = index">
      <div class="form-check">
        <div class="cx-value-label-pair">
          <input
            id="{{
              createAttributeValueIdForConfigurator(attribute, value.valueCode)
            }}"
            type="checkbox"
            class="form-check-input"
            [cxFocus]="{ key: attribute.name + '-' + value.name }"
            [value]="value.valueCode"
            (change)="onSelect()"
            [formControl]="attributeCheckBoxForms[i]"
            name="{{ createAttributeIdForConfigurator(attribute) }}"
          />
          <label
            id="{{
              createValueUiKey('label', attribute.name, value.valueCode)
            }}"
            for="{{
              createAttributeValueIdForConfigurator(attribute, value.valueCode)
            }}"
            class="cx-configurator-attribute-value-label form-check-label"
            >{{ value.valueDisplay }}</label
          >
        </div>
        <div class="cx-value-price">
          <cx-configurator-price
            [formula]="extractValuePriceFormulaParameters(value)"
          ></cx-configurator-price>
        </div>
      </div>
      <cx-configurator-attribute-quantity
        *ngIf="value.selected && withQuantity && !withQuantityOnAttributeLevel"
        (changeQuantity)="onChangeValueQuantity($event, value.valueCode, i)"
        [quantityOptions]="
          extractQuantityParameters(value.quantity, allowZeroValueQuantity)
        "
      ></cx-configurator-attribute-quantity>
    </ng-container>
  </div>
</fieldset>
